import { useEffect, useMemo, useState, useRef } from 'react';
import axios from 'axios';
import { ENDPOINTS as LMSEndpoints } from '../../../Utils/Endpoints';
import { getSessionUserId } from '../../../../../utils/SessionUser';
import Modal from './SeguimientoEstudiantesModal';
import sigmaEdit from '../../../../Pages/img/Editar.png';
import AlertDialog from '../../Shared/AlertDialog';

const PAGE_SIZE = 10;
const nombreTabla = "Seguimiento de Estudiantes";

export default function Catalog() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [query, setQuery] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [page, setPage] = useState(1);
    const [alertConfig, setAlertConfig] = useState({ open: false, message: '', title: 'Información', variant: 'info' });

    const triggerAlert = (message, variant = 'error', title = 'Error') => {
        setModalOpen(false);
        setAlertConfig({ open: true, message, variant, title });
    };
    const editorRef = useRef(null);

    useEffect(() => {
        if (modalOpen && editorRef.current) {
            editorRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [modalOpen, selectedStudent]);

    const loadData = async () => {
        setLoading(true);
        try {
            const idUsuario = getSessionUserId();
            const res = await axios.get(LMSEndpoints.estudianteCursoSeguimiento(idUsuario));

            // Agrupar por estudiante
            const rawData = res.data || [];
            const grouped = rawData.reduce((acc, curr) => {
                const idEst = curr.idEstudiante ?? curr.IdEstudiante;
                const tituloEst = curr.tituloEstudiante ?? curr.TituloEstudiante ?? 'Sin Nombre';
                const idCur = curr.idCurso ?? curr.IdCurso;
                const nombreCur = curr.nombreCurso ?? curr.NombreCurso;
                const fechaTer = curr.fechaTermino ?? curr.FechaTermino;
                const nombreEst = curr.nombreEstado ?? curr.NombreEstado;
                const evalVal = curr.evaluado ?? curr.Evaluado;

                if (!acc[idEst]) {
                    acc[idEst] = {
                        idEstudiante: idEst,
                        tituloEstudiante: tituloEst,
                        cursos: []
                    };
                }
                if (idCur) {
                    acc[idEst].cursos.push({
                        idCurso: idCur,
                        nombreCurso: nombreCur,
                        fechaTermino: fechaTer,
                        nombreEstado: nombreEst,
                        evaluado: evalVal,
                        tienePeticionFecha: curr.tienePeticionFecha ?? curr.TienePeticionFecha,
                        idEstudianteCurso: curr.idEstudianteCurso ?? curr.IdEstudianteCurso
                    });
                }
                return acc;
            }, {});

            const newRows = Object.values(grouped);
            setRows(newRows);

            // Refrescar el modal si está abierto
            setSelectedStudent(prev => {
                if (prev) {
                    const refreshed = newRows.find(s => s.idEstudiante === prev.idEstudiante);
                    return refreshed || prev;
                }
                return prev;
            });

        } catch (e) {
            console.error(e);
            triggerAlert('Error al cargar la información de seguimiento.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { loadData(); }, []);

    const filtered = useMemo(() => {
        const q = query.trim().toLowerCase();
        if (!q) return rows;
        return rows.filter((r) => r.tituloEstudiante.toLowerCase().includes(q));
    }, [rows, query]);

    const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
    useEffect(() => { if (page > totalPages) setPage(1); }, [totalPages, page]);

    const paged = useMemo(() => {
        const start = (page - 1) * PAGE_SIZE;
        return filtered.slice(start, start + PAGE_SIZE);
    }, [filtered, page]);

    const handleViewCourses = (student) => {
        setSelectedStudent(student);
        setModalOpen(true);
    };

    const PageBtn = ({ label, onClick, active, disabled }) => (
        <button
            type="button"
            className={`roles-page-btn ${active ? 'is-active' : ''} ${disabled ? 'is-disabled' : ''}`}
            onClick={onClick}
            disabled={disabled}
        >{label}</button>
    );

    const pageNumbers = (() => {
        const maxToShow = 5;
        let start = Math.max(1, page - 2);
        let end = Math.min(totalPages, start + maxToShow - 1);
        start = Math.max(1, end - maxToShow + 1);
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    })();

    return (
        <div className="panel-sigma-main">
            <div className="roles-shell">
                <div className="roles-topbar">
                    <h2 className="roles-title">{nombreTabla}</h2>
                    <input
                        className="roles-search"
                        placeholder="Buscar por nombre de estudiante…"
                        value={query}
                        onChange={(e) => { setQuery(e.target.value); setPage(1); }}
                    />
                </div>

                <div className="roles-table-wrap">
                    <div className="roles-table-scroller">
                        <table className="roles-table">
                            <thead>
                                <tr>
                                    <th>Estudiante</th>
                                    <th style={{ textAlign: 'center' }}>Cursos Asignados</th>
                                    <th style={{ textAlign: 'center' }}>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paged.map((r, idx) => (
                                    <tr key={`student-${r.idEstudiante || idx}`}>
                                        <td><strong>{r.tituloEstudiante}</strong></td>
                                        <td style={{ textAlign: 'center' }}>
                                            <span style={{
                                                background: '#f1f5f9',
                                                padding: '0.2rem 0.6rem',
                                                borderRadius: '12px',
                                                fontSize: '0.9rem',
                                                fontWeight: 600
                                            }}>{r.cursos.length}</span>
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            <button
                                                type="button"
                                                className="rk-iconbtn rk-iconbtn--edit"
                                                onClick={() => handleViewCourses(r)}
                                                title="Ver Cursos y Fechas"
                                            >
                                                <img src={sigmaEdit} alt="" className="rk-ico" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                {!loading && paged.length === 0 && (<tr key="empty-row"><td colSpan={3}>Sin resultados.</td></tr>)}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="roles-pagination">
                    <div className="roles-pagination-left">
                        <span>{filtered.length} resultados</span>
                    </div>
                    <div className="roles-pagination-right">
                        <PageBtn label="‹" onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1} />
                        {pageNumbers.map(n => (<PageBtn key={n} label={n} onClick={() => setPage(n)} active={n === page} />))}
                        <PageBtn label="›" onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={page === totalPages} />
                    </div>
                </div>

                {modalOpen && selectedStudent && (
                    <div className="roles-editor-slot" ref={editorRef} style={{ marginTop: '2rem' }}>
                        <Modal
                            open={modalOpen}
                            student={selectedStudent}
                            onClose={() => setModalOpen(false)}
                            onSuccess={(msg, variant, title) => {
                                loadData();
                                if (msg) triggerAlert(msg, variant, title);
                            }}
                        />
                    </div>
                )}
            </div>

            <AlertDialog
                open={alertConfig.open}
                title={alertConfig.title}
                message={alertConfig.message}
                variant={alertConfig.variant}
                onClose={() => setAlertConfig({ ...alertConfig, open: false })}
            />
        </div>
    );
}
